module.exports = __webpack_public_path__ + "static/media/rotate2icon.742a6358.svg";